module.exports = {"white":"#FFFFFF","primary":"#143F3D","primary-light":"#8EF5BD","secondary":"#3533DF","secondary-light":"#E2FAFE","tertiary":"#E86F0A","tertiary-light":"#F4A460","quarternary":"#EFEFEF","quarternary-light":"#F7F7F3","grey":"#EFEFEF","grey-light":"#F7F7F3","grey-dark":"#444444","disabled":"#B0B0B0","transparent":"transparent","green":"#143F3D","green-light":"#8EF5BD","green-dark":"#43EE91"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rategravity/frontend/theme/colors.json
// module id = 1467
// module chunks = 0